export default __webpack_public_path__ + "static/media/levels_and_skills.f6da23fc.jpg";